import React from 'react';
import ContentBlock from '../ContentBlock';
import getImageUrl from '../../utils/getImageURL';
import { handleExternalUrlsInMarkdown } from '../../utils/isExternalURL';
import getVideoURL from '../../utils/getVideoURL';
import Video from '../Video';
import Button from '../Button';

export default function FeatureBlock(props) {
  const content = handleExternalUrlsInMarkdown(props.content);
  const { file, autoplay, loop, muted } = props?.video || {};

  return (
    <div style={{ backgroundColor: props.bgColor }}>
      <ContentBlock
        title={props.title}
        description={
          <div>
            <div dangerouslySetInnerHTML={{ __html: content }} />
            {props.link ? (
              <Button solid className="mt-4" href={props.link.link_url}>
                {props.link.link_text} →
              </Button>
            ) : null}
          </div>
        }
        align={props.layout}
        shadow
      >
        {file ? (
          <Video
            video={getVideoURL(file)}
            autoplay={autoplay}
            loop={loop}
            muted={muted}
            isFeatureBlock
          />
        ) : null}
        {!file && props.image ? (
          <div>
            <img
              style={{ margin: 0 }}
              alt={props.image_alt || ''}
              src={getImageUrl(props.image)}
            />
          </div>
        ) : null}
      </ContentBlock>
    </div>
  );
}
